import { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import api from '../services/api';

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password.length < 8) {
      setError('Password must be at least 8 characters.');
      return;
    }
    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    setLoading(true);
    try {
      await api.resetPassword(token, password);
      setSuccess(true);
    } catch (err) {
      setError(err.message || 'Failed to reset password. The link may have expired.');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="login-page">
        <div className="login-card" style={{ textAlign: 'center' }}>
          <div className="login-header">
            <h1 className="login-logo">Stellar<span>Reply</span></h1>
          </div>
          <h2 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '8px' }}>Invalid reset link</h2>
          <p style={{ fontSize: '14px', color: 'var(--text-light)', marginBottom: '24px' }}>
            This link is missing or invalid. Please request a new one.
          </p>
          <Link to="/forgot-password" className="btn btn-primary" style={{ display: 'inline-block' }}>
            Request new link
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-header">
          <h1 className="login-logo">Stellar<span>Reply</span></h1>
        </div>

        {success ? (
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>✅</div>
            <h2 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '8px' }}>Password reset</h2>
            <p style={{ fontSize: '14px', color: 'var(--text-light)', marginBottom: '24px' }}>
              Your password has been updated. You can now log in with your new password.
            </p>
            <Link to="/login" className="btn btn-primary" style={{ display: 'inline-block' }}>
              Go to login
            </Link>
          </div>
        ) : (
          <>
            <h2 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '4px', textAlign: 'center' }}>
              Choose a new password
            </h2>
            <p style={{ fontSize: '14px', color: 'var(--text-light)', textAlign: 'center', marginBottom: '24px' }}>
              Must be at least 8 characters.
            </p>

            {error && (
              <div style={{
                padding: '12px', marginBottom: '16px',
                background: '#fef2f2', border: '1px solid #ef4444',
                borderRadius: '8px', fontSize: '14px', color: '#ef4444',
              }}>
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="form-field">
                <label htmlFor="password">New password</label>
                <input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="At least 8 characters"
                  required
                  autoFocus
                />
              </div>

              <div className="form-field">
                <label htmlFor="confirmPassword">Confirm password</label>
                <input
                  id="confirmPassword"
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="Type it again"
                  required
                />
              </div>

              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading}
                style={{ width: '100%', padding: '12px', marginTop: '8px' }}
              >
                {loading ? 'Resetting...' : 'Reset password'}
              </button>
            </form>

            <p style={{ textAlign: 'center', marginTop: '20px', fontSize: '14px' }}>
              <Link to="/login" style={{ color: 'var(--primary)', textDecoration: 'none' }}>
                Back to login
              </Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
